import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from '@constants/url.constant';
import { ModalService } from '@services/modal/modal.service';
import { StepsService } from '@services/steps/steps.service';
import { Subscription } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { CambioViaPagoPensionService } from '../../core/services/cambio-via-pago-pension.service';
import { StorageService } from '@services/storage/storage.service';
import { BASIC_CLIENT_INFO } from '@constants/data-service.constant';

@Component({
    selector: 'app-cambio-via-pago-datos-personales',
    templateUrl: './cambio-via-pago-datos-personales.component.html',
    styleUrls: ['./cambio-via-pago-datos-personales.component.scss'],
    animations: [
        trigger("myInsertRemoveTrigger", [
            transition(":enter", [
                style({ opacity: 0 }),
                animate("500ms ease-in-out", style({ opacity: 1 })),
            ]),
        ]),
    ],
    standalone: false
})
export class CambioViaPagoDatosPersonalesComponent implements OnInit, OnDestroy {
  public error: boolean = false;
  public loading: boolean = false;
  public email: string;
  public celular: string;
  private readonly subs: Subscription = new Subscription();
  private readonly isBackdropDismiss: boolean = true;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly stepsService: StepsService,
    private readonly modalService: ModalService,
    private readonly service: CambioViaPagoPensionService,
    private readonly storageService: StorageService
  ) {
    stepsService.setCurrentStep(1);
  }

  async ngOnInit(){
    const clientInfo = await this.storageService.get(BASIC_CLIENT_INFO);
    const { email, cellphoneNumber } = clientInfo;
    this.email = email;
    this.celular = cellphoneNumber;
  }
  
  async continue() {
    try {
      this.loading = true;
      await this.router.navigate([`../${ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_DATOS_BANCARIOS}`], {
        relativeTo: this.activatedRoute,
      });
  
    } catch (error) {
      console.error('Error al navegar:', error);
    } finally {
      this.loading = false;
    }
  }
  

  async exit() {
    await this.modalService.cambioViaPagoExitModal();
  }

  async irDatosPersonales() {
    await this.modalService.datosPersonalesModal();
  }

  ngOnDestroy() {
    this.loading = false;
    this.subs.unsubscribe();
  }

}
